import type { StartMyClipperRunData, FinishMyClipperRunData, FinishMyClipperRunVariables } from '@/queries/clipperRun';
import type { RunScoreTransport } from './runScoreRecorder';

type ScoreApi = {
  client: typeof import('@/lib/apollo-client').client;
  start: typeof import('@/queries/clipperRun').START_MY_CLIPPER_RUN;
  finish: typeof import('@/queries/clipperRun').FINISH_MY_CLIPPER_RUN;
};
let api: ScoreApi | undefined;
let loading: Promise<ScoreApi> | undefined;

function loadApi(): Promise<ScoreApi> {
  loading ??= Promise.all([import('@/lib/apollo-client'), import('@/queries/clipperRun')])
    .then(([clientModule, operations]) => {
      api = { client: clientModule.client, start: operations.START_MY_CLIPPER_RUN, finish: operations.FINISH_MY_CLIPPER_RUN };
      return api;
    });
  return loading;
}

export function runScoreIdentity(): string | null {
  try { return localStorage.getItem('token'); } catch { return null; }
}

export const runScoreTransport: RunScoreTransport = {
  async start() {
    const runtime = api ?? await loadApi();
    const result = await runtime.client.mutate<StartMyClipperRunData>({
      mutation: runtime.start, errorPolicy: 'all', fetchPolicy: 'no-cache',
    });
    if (result.errors?.length || !result.data?.startMyClipperRun) throw new Error('run_start_failed');
    return result.data.startMyClipperRun;
  },
  async finish(input) {
    // Admission has already loaded this runtime. Do not yield before a page-close write.
    const runtime = api ?? await loadApi();
    const result = await runtime.client.mutate<FinishMyClipperRunData, FinishMyClipperRunVariables>({
      mutation: runtime.finish, variables: input, errorPolicy: 'all', fetchPolicy: 'no-cache',
      // Keep the initial request alive too if a crash is followed immediately by leaving.
      context: { fetchOptions: { keepalive: true } },
    });
    if (result.errors?.length || !result.data?.finishMyClipperRun) throw new Error('run_finish_failed');
    return result.data.finishMyClipperRun;
  },
};
